import script from "./UserMypage.vue?vue&type=script&setup=true&lang=js"
export * from "./UserMypage.vue?vue&type=script&setup=true&lang=js"

import "./UserMypage.vue?vue&type=style&index=0&id=66e21de2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66e21de2"]])

export default __exports__